export const MODALS = {
    changeRate: "changeRate",
    changeSupplierRate: "changeSupplierRate",
    revoke: "revoke",
    move: "move",
    changeBT: "changeBT",
    ivr: "ivr",
    setLimit: "setLimit",
    setActive: "setActive",
    deletePrefixes: "deletePrefixes",
    modifyGroup: "modifyGroup",
    uploadGan: "uploadGan",
    removeGroup: "removeGroup",
};

export const initialModalState = {
    opened: {
        [MODALS.changeRate]: false,
        [MODALS.changeSupplierRate]: false,
        [MODALS.revoke]: false,
        [MODALS.move]: false,
        [MODALS.changeBT]: false,
        [MODALS.ivr]: false,
        [MODALS.setLimit]: false,
        [MODALS.setActive]: false,
        [MODALS.deletePrefixes]: false,
        [MODALS.modifyGroup]: false,
        [MODALS.uploadGan]: false,
        [MODALS.removeGroup]: false,
    },
    payload: {
        activeStatus: true,
        selectedGroupData: {},
        currentSubDestinationsList: [],
    },
    ui: {
        footerActionsDisabled: false,
        footerActionsLoading: false,
    },
    uiEffects: [],
};

export const MODAL_UI_EFFECTS = {
    resetFooterActions: "resetFooterActions",
    clearTableSelection: "clearTableSelection",
};

export const modalActionTypes = {
    open: "OPEN_MODAL",
    close: "CLOSE_MODAL",
    patchPayload: "PATCH_PAYLOAD",
    patchUi: "PATCH_UI",
    consumeUiEffect: "CONSUME_UI_EFFECT",
};

const footerManagedModals = {
    [MODALS.changeRate]: true,
    [MODALS.changeSupplierRate]: true,
    [MODALS.setActive]: true,
    [MODALS.deletePrefixes]: true,
    [MODALS.setLimit]: true,
};

const modalClosePayloadPatch = {
    [MODALS.changeRate]: { currentSubDestinationsList: [] },
    [MODALS.modifyGroup]: { selectedGroupData: {} },
    [MODALS.uploadGan]: { selectedGroupData: {} },
    [MODALS.removeGroup]: { selectedGroupData: {} },
};

const modalCloseEffects = {
    [MODALS.setLimit]: [MODAL_UI_EFFECTS.clearTableSelection],
};

export const openModal = (modal, payload = null) => ({
    type: modalActionTypes.open,
    modal,
    payload,
});

export const closeModal = (modal, payload = null) => ({
    type: modalActionTypes.close,
    modal,
    payload,
});

export const patchModalPayload = (payload) => ({
    type: modalActionTypes.patchPayload,
    payload,
});

export const patchModalUi = (payload) => ({
    type: modalActionTypes.patchUi,
    payload,
});

export const consumeModalUiEffect = () => ({
    type: modalActionTypes.consumeUiEffect,
});

export const allocatedNumbersModalsReducer = (state, action) => {
    switch (action.type) {
        case modalActionTypes.open:
            return {
                ...state,
                opened: {
                    ...state.opened,
                    [action.modal]: true,
                },
                payload: action.payload
                    ? { ...state.payload, ...action.payload }
                    : state.payload,
                ui: footerManagedModals[action.modal]
                    ? {
                        ...state.ui,
                        footerActionsDisabled: true,
                        footerActionsLoading: true,
                    }
                    : state.ui,
            };
        case modalActionTypes.close:
            return {
                ...state,
                opened: {
                    ...state.opened,
                    [action.modal]: false,
                },
                payload: {
                    ...state.payload,
                    ...(modalClosePayloadPatch[action.modal] || {}),
                    ...(action.payload || {}),
                },
                ui: footerManagedModals[action.modal]
                    ? {
                        ...state.ui,
                        footerActionsDisabled: false,
                        footerActionsLoading: false,
                    }
                    : state.ui,
                uiEffects: [
                    ...state.uiEffects,
                    ...(modalCloseEffects[action.modal] || []),
                ],
            };
        case modalActionTypes.patchPayload:
            return {
                ...state,
                payload: { ...state.payload, ...action.payload },
            };
        case modalActionTypes.patchUi:
            return {
                ...state,
                ui: { ...state.ui, ...action.payload },
            };
        case modalActionTypes.consumeUiEffect:
            return {
                ...state,
                uiEffects: state.uiEffects.slice(1),
            };
        default:
            return state;
    }
};
